import api from "@/apis/bussiness/channelAPI";
import Crud from "./crudBase";
var crud = new Crud("channel", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "channel_id",
      code: "channel_id",      
    }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
